import jsPDF from "jspdf"
import { FileType } from "lucide-react"

import { Button } from "@ui/button"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@ui/tooltip"

interface DownloadAsPdfButtonProps {
    content: string | object
    filename?: string
    variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link"
    size?: "default" | "sm" | "lg" | "icon" | "xs"
    hideText?: boolean
}
export function DownloadAsPdfButton({ content, filename, variant = "default", size = "default", hideText = false }: Readonly<DownloadAsPdfButtonProps>) {
    const handleDonwload = async () => {
        const value = typeof content === "object" ? JSON.stringify(content, null, 2) : String(content)

        const doc = new jsPDF()
        doc.text(value, 10, 10)
        doc.save(filename ? `${filename}.pdf` : `vertesia-document-${new Date().toISOString()}.pdf`)
    }

    if (hideText) {
        return (
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button size={size} variant={variant} onClick={handleDonwload}>
                            <FileType />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        <p>Download as PDF</p>
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        )
    }

    return (
        <Button size="sm" variant="default" onClick={handleDonwload}>
            <FileType className="size-4 mr-1" />
            Export as Docx
        </Button>
    )
}
